module.exports = "/img/unitelfutebol-dark.svg?ed21b89932f246dd2c50aae4202b4708";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/unitelfutebol-dark.svg
// module id = Fp4i
// module chunks = 66